import ListItem from "@/components/AnnouncementsAndTendersList/ListItem";
import {getMapKey} from "@/utils/utils";
import NoResultsLottie from "@/components/noResultsLottie/NoResultsLottie";
import styled from "styled-components";

const NoResultWrapper = styled.div`
	margin: 50px 0;
`

export default function AnnouncementsAndTendersList({data = [], parentSlug = ''}) {
	const noData = data.length === 0

	return (
		<div>
			{noData ? (
				<NoResultWrapper>
					<NoResultsLottie />
				</NoResultWrapper>
			) : (
				Array.isArray(data) && data.map((item, index) => <ListItem key={getMapKey(item, index)} item={item} parentSlug={parentSlug}/>)
			)}
		</div>
	)
}